import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeAgo',
    standalone: true
})
export class TimeAgoPipe implements PipeTransform {
    transform(value: number | string | Date | null | undefined): string {
        let seconds: number;
        
        if (typeof value === 'number') {
            seconds = Math.max(0, Math.floor(value));
        } else if (value instanceof Date || typeof value === 'string') {
            const dt = typeof value === 'string' ? new Date(value) : value;
            if (isNaN(dt.getTime())) {
                return 'Invalid date';
            }
            const diffMs = Date.now() - dt.getTime();
            seconds = Math.max(0, Math.floor(diffMs / 1000));
        } else {
            return 'N/A';
        }
        
        if (seconds < 60) {
            return `${seconds}s ago`;
        }
        if (seconds < 3600) {
            const m = Math.floor(seconds / 60);
            return `${m}m ago`;
        }
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        return `${h}h ${m}m ago`;
    }
}


